<template>
  <div class="collapsible">
    <div class="lesson-item-header" :class="{ opened: opened }">
      <div class="collapsible__button" @click="opened = !opened">
        <vs-icon
          icon="chevron_right"
          class="small-button collapsible__button__arrow"
          color="dark"
        ></vs-icon>
        <div class="lesson-item-header__info">
          <div class="lesson-item-header__info__date">
            <span>
              {{ $moment(date).format('dddd - HH:mm') }}
            </span>
          </div>
          <div class="lesson-item-header__info__room inline" v-if="room">
            <vs-icon :icon="room.icon"></vs-icon>
            <span>{{ room.name }}</span>
          </div>
          <div class="lesson-item-header__info__teacher inline" v-if="teacher">
            <vs-chip transparent>
              <vs-avatar
                :src="
                  teacher.options && teacher.options.avatar
                    ? `${proxy}/static/files/${teacher.options.avatar}`
                    : undefined
                "
              ></vs-avatar>
              {{ teacher.nickname }}
              <span
                color="Coral"
                class="markdown coral default-teacher-chip"
                v-if="teacher.is_default"
              >
                <span>Default</span>
              </span>
            </vs-chip>
          </div>
        </div>
        <lesson-online v-if="is_online"></lesson-online>
        <div
          class="lesson-item-header__info__sub inline"
          v-if="subTeachers.length"
        >
          <span
            ><strong>+ {{ subTeachers.length }}</strong> Sub teachers</span
          >
        </div>
        <div
          class="lesson-item-header__info__assistant inline"
          v-if="assistants.length"
        >
          <span
            ><strong>+ {{ assistants.length }}</strong> assistants</span
          >
        </div>
        <div class="lesson-item-header__info__delimiter"></div>
        <div class="lesson-item-header__info__actions">
          <vs-button
            type="flat"
            icon="delete"
            color="danger"
            @click="deleteItemHandler($event)"
            title="Delete lesson"
          ></vs-button>
        </div>
      </div>
      <div class="lesson__subheader">
        <div class="lesson__subheader__date">
          Started: {{ $moment(date).format('YYYY-MM-DD HH:mm') }}
        </div>
        <div class="lesson__subheader-repeat__freq">
          Repeat: <strong>{{ freq }}</strong
          >, every <strong>{{ interval }}</strong>
        </div>
        <div class="lesson__subheader-repeat__until">
          Until: <strong>{{ $moment(until).format('YYYY-MM-DD') }}</strong>
        </div>
        <div class="lesson__subheader-repeat__count" v-if="count">
          All count: {{ count }}
        </div>
      </div>
    </div>
    <div class="collapsible_content" v-if="opened && lessonToEdit !== null">
      <lesson-form
        lessonType="group"
        :lessonDuration="lessonDuration"
        :schoolyear_id="schoolyear_id"
        :groupFinish="end_to"
        :group="group"
        :branch_id="branch_id"
        v-model="lessonToEdit"
        @saveLesson="saveLessonHandler"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import 'vue-select/dist/vue-select.css'
import LessonForm from '../lessons/lessonGroupInlineForm.vue'
import LessonOnline from '../common/elements/lessonOnline.vue'

export default {
  name: 'GroupFormLessonItem',
  props: ['index', 'lesson', 'schoolyear_id', 'group', 'branch_id'],
  data() {
    let data = {
      proxy: process.env.VUE_APP_PROXY,
      opened: true,
      lessonToEdit: { ...this.lesson },
    }

    return data
  },
  components: {
    LessonForm,
    LessonOnline,
  },
  computed: {
    ...mapState({
      teachersList: (state) => state.teachers.teachers,
      rooms: (state) => state.rooms.rooms,
      years: (state) => state.years.years,
    }),
    until: function () {
      if (this.oldVersion) {
        const schoolyear = this.years.find((y) => y.id == this.schoolyear_id)
        return schoolyear
          ? new Date(schoolyear.date_end_unix * 1000)
          : new Date()
      } else {
        return this.lessonToEdit.until
          ? new Date(this.lessonToEdit.until * 1000)
          : new Date()
      }
    },
    teacher: function () {
      return this.teachersList.find((t) => t.id == this.lessonToEdit.teacher)
    },
    subTeachers: function () {
      if (typeof this.lessonToEdit.other_teachers == 'undefined') return []
      return this.lessonToEdit.other_teachers.map((stId) => {
        const teacher = this.teachersList.find((t) => t.id == stId)
        if (!teacher) return
        const { nickname, options } = teacher
        return {
          nickname,
          options,
        }
      })
    },
    assistants: function () {
      if (!this.lessonToEdit.assistants) return []
      return this.lessonToEdit.assistants.map((stId) => {
        const teacher = this.teachersList.find((t) => t.id == stId)
        if (!teacher) return
        const { nickname, options } = teacher
        return {
          nickname,
          options,
        }
      })
    },
    room: function () {
      return this.rooms.find((r) => r.id == this.lessonToEdit.room)
    },
    schoolyear: function () {
      return this.years.find((y) => y.id == this.schoolyear_id)
    },
    date: function () {
      if (this.oldVersion) {
        const { day, time } = this.lessonToEdit
        const date = new Date()
        date.setDate(date.getDate() + (day - date.getDay() + 1))
        if (time) {
          const [hour, minutes] = time.split(':')
          date.setHours(parseInt(hour, 10))
          date.setMinutes(parseInt(minutes, 10))
          date.setSeconds(0)
          date.setMilliseconds(0)
        }
        return date
      }
      return this.lessonToEdit.date
        ? new Date(this.lessonToEdit.date * 1000)
        : null
    },
    is_online: function () {
      return this.lessonToEdit.is_online
    },
    price: function () {
      return this.lessonToEdit.price || null
    },
    freq: function () {
      return this.oldVersion ? 'weekly' : this.lessonToEdit.freq
    },
    interval: function () {
      return this.oldVersion || !this.lessonToEdit.interval
        ? 1
        : this.lessonToEdit.interval
    },
    count: function () {
      return this.oldVersion || !this.lessonToEdit.count
        ? null
        : this.lessonToEdit.count
    },
    repeat: function () {
      return this.oldVersion || typeof this.lessonToEdit.repeat === 'undefined'
        ? true
        : this.lessonToEdit.repeat
    },
    oldVersionDate: function () {
      return new Date()
    },
    fromOldParams: function () {
      const data = {
        date: this.oldVersionDate,
        freq: 'weekly',
        interval: 1,
        until: new Date(this.schoolyear.date_end_unix * 1000),
        repeat: true,
      }
      return data
    },
    lessonDuration: function () {
      // Возвращаем длительность урока из объекта group (если есть)
      if (this.group && this.group.group_type_id) {
        // Здесь нужно получить duration из group type
        // Пока возвращаем дефолтное значение
        return 60
      }
      return 60
    },
    end_to: function () {
      // Возвращаем дату окончания группы (преобразуем timestamp в Date)
      if (!this.group || !this.group.end_to) return null
      const end_to = this.group.end_to
      return typeof end_to === 'number'
        ? new Date(end_to * 1000)
        : new Date(end_to)
    },
  },
  methods: {
    editItemHandler: function () {
      // Копируем объект занятия для редактирования
      this.lessonToEdit = JSON.parse(JSON.stringify(this.lesson))
      this.$emit('editGroupLesson', this.index, this.date / 1000)
    },

    saveLessonHandler: function () {
      // Получаем актуальный объект из lessonToEdit (v-model синхронизирован)
      this.$emit('saveGroupLesson', this.index, { ...this.lessonToEdit })
    },

    closeLessonFormHandler: function () {
      this.lessonToEdit = null
    },
    deleteItemHandler: function (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Delete lesson',
        text: 'Are you sure you want to delete this lesson?',
        accept: this.deleteLessonCallback,
      })
    },
    deleteLessonCallback: function () {
      this.$emit('deleteGroupLesson', this.index)
    },
  },
  beforeMount: function () {
    this.oldVersion = typeof this.lesson.date === 'undefined' ? true : false
  },
  watch: {
    lessonToEdit: {
      handler() {
        this.$emit('saveGroupLesson', this.index, { ...this.lessonToEdit })
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss">
.lesson-item-header {
  &__info {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 1rem;
    &__date {
      font-size: 1.4rem;
      font-weight: bold;
      padding: 4px 7px;
      border-radius: 5px;
      background-color: var(--table-disabled-bcg);
    }
    &__room {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      gap: 5px;
    }
    &__delimiter {
      flex: 1;
    }
    &__sub,
    &__assistant {
      margin-left: 10px;
    }
  }
  .lesson__subheader {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: 1rem;
    padding-left: 38px;
  }
}
</style>
